import moment from "moment";
import { DATE_FORMAT, TIME_FORMAT } from "./constants";

export const formatDateTime = (time?: number, timezone?: string) =>
  `${moment(time).format(`${DATE_FORMAT}, ${TIME_FORMAT}`)} (${timezone})`;
